import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import * as IBooks from '../../../../../interfaces/merchants/resources/books';
import * as $ from '../../../../../helpers/merchants/resources/helper';

import LabeledContainer from '../../../../common/LabeledContainer';
import BooksSelectedMenu from '../BooksSelectedMenu';
import BooksSelectedStaff from '../BooksSelectedStaff';

interface StaffProps {
  staff: IBooks.Staff;
  onChangeTarget: (targets: {
    course: boolean;
    options: boolean;
    staff?: boolean;
  }) => void;
  args: { course: boolean; options: boolean; staff?: boolean };
  withBorderBottom?: boolean;
  withBorderTop?: boolean;
}

const Staff: FC<StaffProps> = ({
  staff,
  onChangeTarget,
  args,
  withBorderTop,
  withBorderBottom,
}) => {
  const intl = useIntl();
  return (
    <BooksSelectedStaff
      name={
        $.isRandomStaff(staff)
          ? intl.formatMessage({ id: 'books.booksMenu.noSelect' })
          : staff.name
      }
      id={staff.id}
      changeStaff={() => onChangeTarget(args)}
      withBorderTop={withBorderTop}
      withBorderBottom={withBorderBottom}
    />
  );
};

interface Props {
  firstSelected?: IBooks.Switch;
  course: IBooks.Course;
  options: IBooks.Option[];
  staff?: IBooks.Staff;
  onChangeTarget: (targets: {
    course: boolean;
    options: boolean;
    staff?: boolean;
  }) => void;
}

const InputBookingTargetPreview: FC<Props> = ({
  firstSelected,
  course,
  options,
  staff,
  onChangeTarget,
}) => {
  const intl = useIntl();
  if (!firstSelected) {
    // model4以外（コース/スタッフ選択の必要がない場合）
    return (
      <LabeledContainer
        label={intl.formatMessage({
          id: 'books.formsLabel.selectedBooks',
        })}
        contentsPadding={true}
      >
        <BooksSelectedMenu
          name={course.name}
          options={options}
          price={course.price}
          duration={course.duration}
          changeTarget={() => onChangeTarget({ course: true, options: true })}
          changeOption={() => onChangeTarget({ course: false, options: true })}
        />
      </LabeledContainer>
    );
  }
  return firstSelected === IBooks.Switch.Course ? (
    <div>
      <LabeledContainer
        label={intl.formatMessage({
          id: 'books.formsLabel.selectedBooks',
        })}
        contentsPadding={true}
      >
        <BooksSelectedMenu
          name={course.name}
          options={options}
          price={course.price}
          duration={course.duration}
          changeTarget={() =>
            onChangeTarget({ course: true, options: true, staff: true })
          }
          changeOption={() =>
            onChangeTarget({ course: false, options: true, staff: true })
          }
        />
        {staff && (
          <Staff
            staff={staff!}
            onChangeTarget={onChangeTarget}
            args={{ course: false, options: false, staff: true }}
            withBorderTop={true}
          />
        )}
      </LabeledContainer>
    </div>
  ) : (
    <div>
      <LabeledContainer
        label={intl.formatMessage({
          id: 'books.formsLabel.selectedBooks',
        })}
        contentsPadding={true}
      >
        <Staff
          staff={staff!}
          onChangeTarget={onChangeTarget}
          args={{ course: true, options: true, staff: true }}
          withBorderBottom={true}
        />
        <BooksSelectedMenu
          name={course.name}
          options={options}
          price={course.price}
          duration={course.duration}
          changeTarget={() =>
            onChangeTarget({ course: true, options: true, staff: false })
          }
          changeOption={() =>
            onChangeTarget({ course: false, options: true, staff: false })
          }
        />
      </LabeledContainer>
    </div>
  );
};

export default InputBookingTargetPreview;
